export enum OpportunitiesStatusTypes {
    Solicitation = 'Solicitation',
    CombinedSynopsisOrSolicitation = 'Combined Synopsis/Solicitation',
    Presolicitation = 'Presolicitation',
    SourcesSought = 'Sources Sought',
    AwardNotice = 'Award Notice',
    SpecialNotice = 'Special Notice',
    Justification = 'Justification',
    SaleOfSurplusProperty = 'Sale of Surplus Property'
}